@app.directive 'shopifyButton', ($state, csConfig, ShopifyService, LocationService, ModalService, AnalyticsService, $location, DiscountService) ->
  restrict: 'E'
  scope: {}
  controllerAs: 'shopifyButton'
  controller: ->

    @discountCode = DiscountService.discountCode
    @discount = DiscountService.discount # Will go away one /butchers?discount_id is finished

    @premiumVariantID = 13403946119
    @premiumVariantID = 20034967495 if csConfig.env == 'production'

    @isInUS = ->
      LocationService.isInUS()

    @isJoule = =>
      @sku == 'cs10001'

    @currentUser = $state.currentUser

    if @sku
      @variant = ShopifyService.variantForSku @sku
      if @variant
        if @discount && @discount.valid # Will go away one /butchers?discount_id is finished
          @url = "#{csConfig.shopifyEndpoint}/cart/#{@variant.id}:1?discount=#{@discount.code}"
        else if @discountCode
          if _.startsWith(@discountCode, 'prx')
            @url = "#{csConfig.shopifyEndpoint}/cart/#{@variant.id}:1,#{@premiumVariantID}:1?discount=#{@discountCode}"
          else
            @url = "#{csConfig.shopifyEndpoint}/cart/#{@variant.id}:1?discount=#{@discountCode}"
        else if @currentUser
          @url = "#{csConfig.chefstepsEndpoint}/api/v0/shopping/users/add_to_cart?variant_id=#{@variant.id}"
        else
          @url = "#{csConfig.shopifyEndpoint}/cart/add?id=#{@variant.id}"

        switch @sku
          when 'cs10001'
            # Button behavior for Joule
            if @isInUS()
              @showInternational = false
              @buttonPrice = @variant.price
              @comparePrice = @variant.compare_at_price
            else
              @showInternational = true
              @openInternationalJoule = ->
                ModalService.open('internationalJoule', {type: 'normal', sku: @sku, user: @currentUser, checkoutUrl: @url, outOfStock: @variant.inventory_quantity <= 0})
          else
            @buttonPrice = @variant.price
            @comparePrice = @variant.compare_at_price
      else
        Rollbar.error("ShopifyButton - @variant not set for button at url: #{$state.current.url}")

    @openJouleWaitlist = ->
      AnalyticsService.track 'Joule Waitlist Modal Opened'
      ModalService.open('jouleWaitlist')

    @showOutOfStock = =>
      return false if !@variant
      return false if @variant.inventory_quantity > 0
      return false if @showInternational
      return false if @allowOutOfStockPurchase()
      (@showQuantity || @isJoule())



    @allowOutOfStockPurchase = =>
      # At the moment only checks the validity of the discount, allowing a user to purchase when out of stock
      # Typically, when an item is out of stock, we won't allow the customer to purchase
      # This allows us to retain the out of stock behavior but still allow a set of customers (from a promotion or campaign) to still purchase the out of stock item
      @discount?.valid

    @showDiscountMessage = =>
      if @discount
        (@discount?.valid && @discount?.code != 'allowOutOfStockPurchase') ? true : false

    this

  bindToController: {
    title: '='
    theme: '='
    sku: '='
    showPrice: '='
    showQuantity: '='
  }
  templateUrl: "/assets/templates/components/customButton/shopifyButton/shopifyButton.html"
